const cssUrl = `${import.meta.env.VITE_CDN_ROOT}${import.meta.env.VITE_ASCEND_AWESOME_VERSION}/css/trustage-aa--wc.css`
const componentCssUrl = `${import.meta.env.VITE_CDN_ROOT}${import.meta.env.VITE_ASCEND_AWESOME_VERSION}/css/components/PropertyContainer.css`;

const t = document.createElement('template')
t.innerHTML = `
<link href="${cssUrl}" rel="stylesheet" />
<link href="${componentCssUrl}" rel="stylesheet" />
`
const TemplatePropertyContainerStyles = t
export { TemplatePropertyContainerStyles }
